module.exports = __webpack_public_path__ + "static/media/unlimited-financials-horz-logo-2-color.b7b19665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unlimited-financials-horz-logo-2-color.svg
// module id = 88
// module chunks = 13